<template>
  <div class="animated fadeIn list-of-po">
    <b-card>
      <div slot="header">Bread Purchase Order List
        <div class="card-header-actions">

          <b-dropdown text="Add" variant="primary mr-1" >
            <b-dropdown-item @click="add">Manual</b-dropdown-item>
            <b-dropdown-item @click="addGenerateConfirm" >Generate PO</b-dropdown-item>
          </b-dropdown>

          <b-button variant="primary mr-1" @click="edit">{{this.model.status_sendtovendor ? 'View': 'Edit'}}</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" :disabled="disabledDelete">Delete</b-button>
          <b-button variant="primary mr-1" @click="sendToVendorConfirm" :disabled="this.model.status_sendtovendor">Send to Vendor</b-button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print">Supplier PO</b-dropdown-item>
            <b-dropdown-item @click="printdo" >DO</b-dropdown-item>
            <b-dropdown-item @click="printdounsend" >DO Unsend</b-dropdown-item>
            <b-dropdown-item @click="printwholesaleinv" >Invoice Wholesale</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Export ForeCast" variant="primary mr-1" >
            <b-dropdown-item @click="showFrmVendor=true">Vendor</b-dropdown-item>
            <b-dropdown-item @click="showFrmCustomer=true" >Customer</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Receiving" variant="primary mr-1" >
            <b-dropdown-item @click="receivingSupplier">Supplier</b-dropdown-item>
            <b-dropdown-item @click="receivingCustomer" >Customer</b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Order No. (% for wildcard)"></b-form-input>
                    </b-input-group>
                  </b-col>
              </b-row>          
            <b-row>
              <b-col lg="10">
                  <b-input-group >
                    <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>            
        </b-col>
        <b-col lg="5">
              <b-input-group >
                <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
                <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
                <b-form-input v-model="tblData.item" placeholder="Material/Service Name"></b-form-input>
              </b-input-group>

            <b-input-group class="mt-1 mb-1">
              <b-input-group-prepend><label class='label-input-group'>View Option</label></b-input-group-prepend>
              <b-form-radio-group  v-model="viewOption" class="mt-1">
                  <b-form-radio v-model="viewOption" value="Header">Header/Summary</b-form-radio>
                  <b-form-radio v-model="viewOption" value="Lines">Line/Items</b-form-radio>
              </b-form-radio-group>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined small 
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(status_sendtovendor)="data">
          <span v-if="(data.item.status_sendtovendor == 'Sent')" :class="data.item.status_sendtovendor=='Sent'?'alert-success navbar-link p-1':''" style="cursor: pointer;">
            <span>{{data.item.status_sendtovendor}}</span>
          </span>
          <span v-else>
            <span>{{data.item.status_sendtovendor}}</span>
          </span>
        </template>

        <template v-slot:cell(nilainett)="data">
          {{data.item.nilainett | numFormat}}
        </template>
        <template v-slot:cell(nilaippn)="data">
          {{data.item.nilaippn | numFormat}}
        </template>
        <template v-slot:cell(nilaidue)="data">
          {{data.item.nilaidue | numFormat}}
        </template>
        <template v-slot:cell(nilaiduereceiving)="data">
          {{data.item.nilaiduereceiving | numFormat}}
        </template>
        <template v-slot:cell(totitemreceived)="data">
          <span v-if="(data.item.totitemreceived>0)"> {{data.item.totitemreceived | numFormat}} of {{data.item.totitemordered | numFormat}} items </span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
      <b-modal v-model="showSendConfirm" title="Send to Vendor?" :centered="true" @ok="sendToVendor">
        <p class="mb-1">This <b>{{model.orderno}}</b> will be send to vendor.</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-supplier @click="onSelectLkuVendor"></lku-supplier>
        </b-modal>  
    <b-modal v-model="showFrmVendor" header-bg-variant="primary" size="md" title="Forecast- Vendor" :centered="true" @ok="exportFcVendor" ok-title="Export">
        <b-row >
          <b-col>
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Supplier/Vendor</label></b-input-group-prepend>
              <b-form-input v-model="forecastvendor.vendorinfo" placeholder="Supplier/Vendor"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuVendorShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group >
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Date range</label></b-input-group-prepend>
                <b-form-input v-model="forecastvendor.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="forecastvendor.tgl2" type="date" ></b-form-input>
            </b-input-group >
          </b-col>
      </b-row>
    </b-modal>

    <b-modal v-model="showFrmCustomer" header-bg-variant="primary" size="md" title="Forecast- Customer" :centered="true" @ok="exportFcCustomer" ok-title="Export">
        <b-row >
          <b-col>
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Customer/Group</label></b-input-group-prepend>
              <b-form-input v-model="forecastcustomer.customer" placeholder="Customer or Group/Holding"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group >
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Date range</label></b-input-group-prepend>
                <b-form-input v-model="forecastcustomer.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="forecastcustomer.tgl2" type="date" ></b-form-input>
            </b-input-group >
          </b-col>
      </b-row>
    </b-modal>

    <b-modal v-model="showAddGenerateConfirm" header-bg-variant="primary"  title="Generate PO" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="12"> 
                <b-input-group >
                  <b-input-group-prepend><label style="width:100px !important;">Order Date</label></b-input-group-prepend>
                  <b-form-input v-model="model.orderdate" type="date" :state="!$v.model.orderdate.$error"></b-form-input>
                  <b-input-group-append><label style="max-width:250px !important;" class="m-2">FROM PO -Order Date</label></b-input-group-append>
                  <b-form-input v-model="model.orderdateb4" type="date" :state="!$v.model.orderdateb4.$error"></b-form-input>
              </b-input-group >
              </b-col>
          </b-row >  
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="addGenerate"><i class="fa fa-paper-plane"></i> Generate</b-button>
              <b-button variant="secondary" class="ml-1" @click="showAddGenerateConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal> 

  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import procure from "../../apis/bakeryorder";
import dropdown from "../../data/dropdown";
import lkuSupplier from "../lookup/lkuSupplier";
import lkuCustomer from "../lookup/lkuCustomer";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading, lkuSupplier,lkuCustomer},
  mixins: [validationMixin],
  validations: {
        forecastcustomer: {
            customer_id: { required },
            tgl1: { required },
            tgl2: { required }
        },
        forecastvendor: {
            vendor_id: { required },
            tgl1: { required },
            tgl2: { required }
        },
        model: {
            orderdateb4: { required },orderdate: { required }  
        },
  }, 
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showSendConfirm: false,
      showFrmVendor:false,
      lkuVendorShow:false,
      forecastvendor:{vendor_id:'', tgl1:'', tgl2:''},
      showFrmCustomer:false,
      showAddGenerateConfirm: false,
      forecastcustomer:{customer_id:'', tgl1:'', tgl2:''},
      model:{tglgenerate:''},
      lkuCustomerShow:false,
      disabledCloseVoid:true,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      viewOption:'Header',
      reportUrl: `${location.origin}/#load`,
        items: [],
      tblData: {
        status:"",
        postgroup:"",
        page: 1,
        limit: 15,
        total: 0,
        tgl1:moment().subtract(1, 'months').format('YYYY-MM-DD'),
        tgl2:moment().format('YYYY-MM-DD'),
        tglgenerate: moment().format('YYYY-MM-DD'),
        sortBy: 'orderdate',
        sortDesc: true,
        DimCol:'Dim1',
        outstand:'',
        orderwholesale: '0'
      },
      limit:15,
      pagination: false,      
      tblFields: [
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "orderno",
            thStyle: "width:100px",
            label: "Order Number",
            sortable: true
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "Order Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "remark",
            thStyle: "width:300px",
            label: "Description",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilainett",
            label: "Subtotal",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilaippn",
            label: "VAT",
            thStyle: "width:80px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaidue",
            label: "Total Amount Order",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "totitemreceived",
            label: "Item Received",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nilaiduereceiving",
            label: "Total Amount Receving",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "status_sendtovendor",
            label: "Send to Vendor",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          
        ],
      model:{},
      postGroups:[],
      approvalStatus : dropdown.approvalStatus,
      outstandSlct : dropdown.openClose,
      forecastcustomer:{
        closeVoid:'closed',
        closevoidnote:'',
        options: [
          { text: 'Closed', value: 'closed' },
          { text: 'Void', value: 'void' },
        ]
      },
      forecastvendor:{trackStatus:''},
      showStatusUpdate:false,      
    };
  },
  computed: {
    invalidFcCustomer() {
      this.$v.forecastcustomer.$touch();
      return this.$v.forecastcustomer.$invalid;
    },
    invalidFcVendor() {
      this.$v.forecastvendor.$touch();
      return this.$v.forecastvendor.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    }, 
    
    viewOption : function(newval) {
      // this.clearFilter();
      if (newval=='Header') {
        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "orderno",
            thStyle: "width:100px",
            label: "Order Number",
            sortable: true
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "Order Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "remark",
            thStyle: "width:300px",
            label: "Description",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilainett",
            label: "Subtotal",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilaippn",
            label: "VAT",
            thStyle: "width:80px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaidue",
            label: "Total Amount Order",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "totitemreceived",
            label: "Item Received",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nilaiduereceiving",
            label: "Total Amount Receving",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "status_sendtovendor",
            label: "Send to Vendor",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push({
            key: `${dims[i].value}Txt`,
            label: dims[i].text,
            sortable: true
          });
        }
      } else {
        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "orderno",
            thStyle: "width:120px",
            label: "Order Number",
            sortable: true
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "Order Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "customer_group",
            label: "Customer Group",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "itemname",
            thStyle: "width:200px",
            label: "Item",
          },
           {
            key: "itemcategory",
            thStyle: "width:200px",
            label: "Item Category",
          },
          {
            key: "qtyOrder",
            label: "Qty Order",
            thStyle: "width:80px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          
        ];
      }
      
      let newFields = [];
      this.tblFields.map((data,index)=>{
        if(!data.hide){
          newFields.push(data);
        }
      })
      this.tblFields = newFields;
      this.refresh();
    },

  },  
  methods: {
    onSelectLkuCustomer: async function (_selected) {
        this.forecastcustomer.customer_id = _selected.customer_id;
        this.forecastcustomer.CustCode = _selected.CustCode;
        this.forecastcustomer.CustName = _selected.CustName;
        this.forecastcustomer.customer = `${_selected.CustName} | ${_selected.CustCode}`;
        this.lkuCustomerShow=false;
    },    
    onSelectLkuVendor: async function (_selected) {
        this.forecastvendor.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.forecastvendor.vendor = _selected.vendor_code;
        this.forecastvendor.vendor_id = _selected.vendor_id;
        this.lkuVendorShow=false;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.polist) {
            this.tblData[key] = filter.polist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.polist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.polist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  let list =[];
                  this.tblData.orderwholesale = '0';
                  if (this.viewOption=='Header') {
                      list = await procure.listheader(this.tblData);
                  } else {
                      list = await procure.list(this.tblData);
                  }
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              let list =[];
              this.tblData.orderwholesale = '0';
                  if (this.viewOption=='Header') {
                      list = await procure.listheader(this.tblData);
                  } else {
                      list = await procure.list(this.tblData);
                  }
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.item=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.requestno=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status','outstand','orderwholesale'];
      let filtered = false;
      const polist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              polist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          polist.page=this.tblData.page;
          polist.limit=this.tblData.limit;
          polist.sortBy=this.tblData.sortBy;
          polist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.polist=polist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add(){
      this.saveFilter();
      router.push("order-form");
    },

    addGenerateConfirm: async function () {
      this.showAddGenerateConfirm = true;
      this.model.tglgenerate= moment().format('YYYY-MM-DD');
    }, 
    addGenerate: async function(evt){
        evt.preventDefault()
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('frmdata obj : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          } else {
            try {
                this. isLoading=true 
                this.showAddGenerateConfirm = false;
                const resp = await procure.generatePO(this.model);
                console.log('addGenerate resp: ', resp);
                this.isLoading = false;
                this.refresh();
                if (resp) {
                  toastr.success('Success Generate PO.','INFO!',10000);
                }else{
                  toastr.warning(resp,'WARNING!',10000);
                }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
          }
    },

    edit: function() {
        if (this.model.pohdrkey) {
          this.saveFilter();
          // router.push({name :'bakery.orderfrm', params: { pohdrkey: this.model.pohdrkey, status_sendtovendor: this.model.status_sendtovendor}});
          router.push({name :'bakery.orderfrm', params: { pohdrkey: this.model.pohdrkey, status_sendtovendor: this.model.status_sendtovendor, customer_group: this.model.customer_group}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },

    sendToVendorConfirm() {
        if (this.model.pohdrkey) {
          this.showSendConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Send to Vendor!');
        }
    },
    sendToVendor: async function() {
      try {
        this.showSendConfirm = false;
        this.isLoading=true;
        const resp = await procure.sendtovendor(this.model);
        this.refresh();
        this.isLoading=false;
        if (resp) {
            toastr.success(`Success Send to Vendor.`, "INFO!",10000);
        }else{
            toastr.warning(resp,'WARNING!',10000);
        }
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    receivingSupplier() {
        if (this.model.pohdrkey) {
          this.saveFilter();
          router.push({name :'bakery.receivingsupplierfrm', params: { pohdrkey: this.model.pohdrkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    receivingCustomer() {
        if (this.model.pohdrkey) {
          this.saveFilter();
          router.push({name :'bakery.receivingcustomerfrm', params: { pohdrkey: this.model.pohdrkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.pohdrkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await procure.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.pohdrkey==this.model.pohdrkey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      if( record.status === '111' ){
        this.disabledDelete = true;
        this.disabledCloseVoid   = false;
      }else{
        this.disabledDelete = false;
        this.disabledCloseVoid   = true;
      }

      // if (this.model.pohdrkey == record.pohdrkey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    
    print: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.print(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printdo: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.printdo(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    }, 
    
    printdounsend: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.printdounsend(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printwholesaleinv: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.printwholesaleinv(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },       
    exportFcVendor: async function(evt) {
      evt.preventDefault()
      if (this.invalidFcVendor) {
          console.log('validation : ', this.$v.forecastvendor);
          console.log('frmdata obj : ',this.forecastvendor);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
          try {
            this.isLoading=true;
              this.forecastvendor.tgl1 = moment(this.forecastvendor.tgl1).format('YYYY-MM-DD');
              this.forecastvendor.tgl2 = moment(this.forecastvendor.tgl2).format('YYYY-MM-DD');
              const response = await procure.exportFcVendor(this.forecastvendor);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ForeCast_order_supplier.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);

            this.isLoading=false;    
          } catch (error) {
              this.isLoading=false;            
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }
      }
    },    
    exportFcCustomer: async function(evt) {
      evt.preventDefault()
      if (this.invalidFcCustomer) {
          console.log('validation : ', this.$v.forecastcustomer);
          console.log('frmdata obj : ',this.forecastcustomer);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
          try {
              this.isLoading=true;
              this.forecastcustomer.tgl1 = moment(this.forecastcustomer.tgl1).format('YYYY-MM-DD');
              this.forecastcustomer.tgl2 = moment(this.forecastcustomer.tgl2).format('YYYY-MM-DD');
              const response = await procure.exportFcCustomer(this.forecastcustomer);
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'customer_order_summary.xlsx');
              document.body.appendChild(link);
              link.click();
              this.isLoading=false;    
          } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
      }
    },      
    exportxls: async function() {
        this.isLoading=true;
        try {
           const response = await procure.exportxls(this.tblData);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'bread_order_list.xlsx');
            document.body.appendChild(link);
            link.click();
            this.isLoading=false;    
        } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
        }
    },    
    close(){
        // router.push({name:'procurement.home'});
          router.push("home");
    }

  }
};
</script>
